<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        AppMessage Details
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/keywords_list">Back</router-link></li>        
        <li class="active">Add / Update AppMessages</li>
      </ol>
    </section>
    <section class="content">
      <form @submit.prevent="addOrUpdate" action="#"  method="post">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xs-6">
            <label for="weightage">AppMessage Type</label>
            <div class="form-group">
              <label class="radio-inline">
                <input type="radio" name="appmessagetype"  value="keyword" v-model="appmessagetype">Keyword
              </label>
              <label class="radio-inline">
                <input type="radio" name="appmessagetype" value="generic" v-model="appmessagetype">Purposal
              </label>              
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="name">Campaign</label>
              <input type="text" autocomplete='off' v-bind:class="{'form-group--error': (submitted) || keywordExistError }" v-model="gRowObj.Campaign" class="form-control" id="Campaign" placeholder="Campaign"  />
              <span v-if="submitted" class="text-red pull-right">Please enter Campaign.</span>
              <span v-if="submitted" class="text-red pull-right">Campaign already exists.</span>
            </div>
          </div>
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="name">AppMessage Name</label>                  
               <input type="text" autocomplete='off' v-bind:class="{'form-group--error': (submitted) || keywordExistError }" v-model="gRowObj.keyword" class="form-control" id="keyword" placeholder="Keyword"  />
              <span v-if="submitted" class="text-red pull-right">Please enter keyword.</span>
              <span v-if="submitted" class="text-red pull-right">AppMessage already exists.</span>                  
            </div>
          </div>
          
        </div>
        <div class="row">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="name">{{primaryLangText}}</label>
              <textarea autocomplete='off' v-bind:class="{'form-group--error': (submitted) || keywordExistError }" v-model="gRowObj.primarylanguage" class="form-control" id="primarylanguage" placeholder="Language 1"></textarea>
              <span v-if="submitted" class="text-red pull-right">Please enter Language.</span>
              <span v-if="submitted" class="text-red pull-right">Language already exists.</span>
            </div>
          </div>
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="name">{{secondaryLangText}}</label>                  
              <textarea autocomplete='off' v-bind:class="{'form-group--error': (submitted) || keywordExistError }" v-model="gRowObj.secondarylanguage" class="form-control" id="secondarylanguage" placeholder="Language 2"></textarea>
              <span v-if="submitted" class="text-red pull-right">Please enter Language.</span>
              <span v-if="submitted" class="text-red pull-right">Language already exists.</span>                  
            </div>
          </div>
          
        </div>

        <!-- <div class="row">
          <div class="form-group col-md-12 col-lg-12 col-xs-12">
            <div class="padding-15px">
              <label>Exclusive</label>
            </div>
            <div class="padding-15px">
              <label class="checkbox-inline">
                <input type="checkbox" name="isExclusive" id="isExclusive" :checked="gRowObj.isExclusive"  v-bind:value="gRowObj.isExclusive" v-model="gRowObj.isExclusive"> Is Exclusive?
              </label>
            </div>
          </div>
        </div>  -->
        <div class="row">
        </div>
        <div class="row">
          <div class="action-button">
            <button type="button" class="btn btn-primary" @click="close">Cancel</button>
            <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
          </div>
        </div>
      </form>
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  // import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  // import _ from 'lodash'
  // import { appTypes, products, appPackages, channels, languages } from './../../../config/constants'
  export default {
    name: 'modal',
    // validations: {
    //   gRowObj: {
    //     appmessagetype: {},
    //     campaign: {},
    //     appmessagename: {},
    //     primarylanguage: {},
    //     secondarylanguage: {}
    //   }
    // },
    data () {
      return {
        primaryLangText: {},
        secondaryLangText: {},
        loading: false,
        keywordExistError: false,
        msg: 'Please wait...',
        validationErrors: [],
        gRowObj: {
          id: null,
          appmessagetype: 'keyword',
          campaign: '',
          appmessagename: '',
          primarylanguage: '',
          secondarylanguage: ''
        },
        domain: {
          'localhost': {
            primaryLangText: 'English',
            secondaryLangText: 'Hindi'
          },
          'dashboard.mynivi.in': {
            primaryLangText: 'English',
            secondaryLangText: 'Hindi'
          },
          'india-dashboard-staging.herokuapp.com': {
            primaryLangText: 'English',
            secondaryLangText: 'Hindi'
          },
          'eu-dashboard-staging.herokuapp.com': {
            primaryLangText: 'English',
            secondaryLangText: 'Swahili'
          },
          'dashboard.mynivi.ke': {
            primaryLangText: 'English',
            secondaryLangText: 'Swahili'
          }
        },
        submitted: false,
        actionToBePerformed: 'Add Keyword'
      }
    },
    methods: {
      loadApps (deployed = false) {
        this.loading = true
        let url = 'app'
        // url += deployed ? '?deployed=1' : ''
        api.buildRequest(url, 'GET')
          .then(response => {
            if (response.status === 200) {
              // if (deployed) {
              //   this.conversationApps = response.data.payload.apps
              // } else {
              //   this.conversationApps = response.data.payload.apps
              // }
              // console.log(this.conversationApps)
            }
            if (this.$route.query.message) {
              this.getSelectappMsg(this.$route.query.message)
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      display () {
        // console.log('source', this.source)
        // console.log('destination', this.destination)
      },
      close () {
        // console.log('closing the modal')
        this.submitted = false
        this.$router.replace('messages-dashboard')
      },
      addOrUpdate (e) {
        console.log('inside addOrUpdate function')
        // console.log(this.actionToBePerformed)
        // console.log(this.gRowObj)
        this.submitted = true
        this.keywordExistError = false
        let queryParams = {
          selector: {
            campaign: this.gRowObj.campaign,
            isdeleted: false
          }
        }
        if (this.$route.query.keywordId && !this.$route.query.action) {
          queryParams.selector._id = { $ne: this.$route.query.keywordId }
        }
        // const isKeywordExist = this.checkKeywordExists(queryParams)
        // NOW CHECK IF THAT KEYWORD ALREADY EXISTS
        api.buildRequest('/checkappMsgExists', 'POST', queryParams)
        .then(response => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            if (response.data.payload === null) {
              let apiToCall = 'addAppmsg'
              this.loading = true
              let trimmedObj = {}
              this.gRowObj.id = this.gRowObj.campaign
              trimmedObj = this.trimJsonObj(this.gRowObj)
              if (this.gRowObj.appmessagename === '' || this.gRowObj.appmessagename === null) {
                delete trimmedObj.appmessagename
              }
              if (this.gRowObj.campaign === '' || this.gRowObj.campaign === null) {
                delete trimmedObj.campaign
              }
              console.log(trimmedObj)
              const newRowObj = {
                id: trimmedObj.campaign,
                campaign: trimmedObj.campaign,
                data: trimmedObj
              }
              let params = {}
              if (this.$route.query.keywordId) {
                apiToCall = 'updateKeyword'
                if (this.$route.query.action === 'copyKeyword') {
                  delete params.updatedRow
                  params.newRow = Object.assign({}, newRowObj)
                  apiToCall = 'addAppmsg'
                } else {
                  params.updatedRow = Object.assign({}, newRowObj)
                  params.updatedRow._id = this.$route.query.keywordId
                  delete params.newRow
                }
                this.performKeywordOperation(params, apiToCall, 'Keyword added successfully.')
              } else {
                delete params.updatedRow
                params.newRow = Object.assign({}, newRowObj)
                // console.log('addKeyword')
                // console.log(`params.newRow=${JSON.stringify(params.newRow)}`)
                this.performKeywordOperation(params, apiToCall, 'Keyword updated successfully.')
              }
            } else {
              this.keywordExistError = true
            }
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      getSelectappMsg (message) {
        console.log('getSelectappMsg')
        this.loading = true
        let skip = 0
        let limit = 20
        let selector = {}
        if (message !== '' && message !== undefined) {
          selector = {_id: message}
        }
        let queryParams = {
          message: message,
          selector: selector,
          skip: skip,
          limit: limit,
          sort: {
            createdAt: -1
          }
        }
        console.log(queryParams)
        api.buildRequest('/getSelectappMsg', 'POST', queryParams)
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            const MessageDetails = response.data.payload.Data
            console.log('get data', response.data)
            // const MessageData = MessageDetails.data
            this.gRowObj.id = MessageDetails.keyword
            this.gRowObj.keyword = MessageDetails.keyword
            if (this.$route.query.action === 'copyKeyword') {
              this.gRowObj.keyword = ''
            }
            this.gRowObj.campaign = MessageDetails.conversation || ''
            this.gRowObj.appmessagetype = MessageDetails.type || ''
            this.gRowObj.appmessagename = MessageDetails.product || ''
            this.gRowObj.primarylanguage = MessageDetails.config.en || ''
            this.gRowObj.secondarylanguage = MessageDetails.config.hi || ''
            console.log('this.gRowObj')
            console.log(this.gRowObj)
            console.log('this.destination')
            console.log(JSON.stringify(this.destination))
          }
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      performKeywordOperation (params, apiToCall, message) {
        // console.log(`params=${JSON.stringify(params)}`)
        api.buildRequest(apiToCall, 'POST', params)
          .then(response => {
            if (response.status === 200) {
              this.loading = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : message
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      /**
       * @author Sarang Sutar <sarang.sutar@mobifillia.com>
       * @description Trim JSON Object
       */
      trimJsonObj (obj) {
        const trimmedObj = {}
        Object.keys(obj).forEach(function (key) {
          console.log(key, obj[key])
          trimmedObj[key] = obj[key]
          if (obj[key] !== undefined && typeof obj[key] === 'string') {
            trimmedObj[key] = obj[key].trim()
          }
        })
        delete trimmedObj._id
        return trimmedObj
      }
    },
    mounted () {
      var domainname = window.location.hostname
      this.primaryLangText = this.domain[domainname].primaryLangText
      this.secondaryLangText = this.domain[domainname].secondaryLangText
      console.log('route query')
      // console.log(this.$route.query.keywordId)
      // this.loadApps(true)
      this.gRowObj = {
        id: null,
        appmessagetype: '',
        campaign: '',
        appmessagename: '',
        primarylanguage: '',
        secondarylanguage: ''
      }
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
</style>


// WEBPACK FOOTER //
// appMessagedetails.vue?fb68ad96